import Vue from 'Vue';
import Vuex from 'vuex';
import _ from 'lodash';

Vue.use(Vuex);
/**
 * the store to hold all the variables needed by multiple components
 * @type {Vuex.Store}
 */
let store = new Vuex.Store({
    state: {
        appId: '',
        showScrollOverlay: false,
        contents: {
            page: 1,
            meta: {
                pages: 1
            },
            data: []
        },
        mapStyle: {
            width: "100%",
            height: "600px"
        },
        filters: {
          keyword: null,
          categories: []
        },
        categories:[],
        initialFeaturesList:[],
        isLoading: true,
        activeTrip: null,
        detailViewOpen: false, //@deprecated, the detailview is not used right now
        offerDetailsOpen: false,
        tourDetailsOpen: false,
        mapIdle: false,
        featureId: '',
        mapType: ''
    },
    getters: {
        showScrollOverlay: (state) => {
            return state.showScrollOverlay;
        },
        contents: (state) => {
            return state.contents;
        },
        isLoading: (state) => {
            return state.isLoading;
        },
        mapStyle: (state) => {
            return state.mapStyle;
        },
        activeTrip: (state) => {
            return state.activeTrip;
        },
        detailViewOpen: (state) => {
            return state.detailViewOpen;
        },
        offerDetailsOpen: (state) => {
            return state.offerDetailsOpen;
        },
        tourDetailsOpen: (state) => {
            return state.tourDetailsOpen;
        },
        appId: (state) => {
            return state.appId;
        },
        categories: (state) => {
            return state.categories;
        },
        filters: (state) => {
          return state.filters;
        },
        mapIdle: (state) => {
            return state.mapIdle;
        },
        featureId: (state) => {
            return state.featureId;
        },
        mapType: (state) => {
            return state.mapType;
        },
        initialFeaturesList: (state) => {
            return state.initialFeaturesList;
        }
    },
    mutations: {
        setIsLoading: (state, isLoading) => {
          state.isLoading = isLoading;
        },
        setActiveTrip: (state, trip) => {
            state.activeTrip = trip;
        },
        setDetailViewOpen: (state, isOpen) => {
            state.detailViewOpen = isOpen;
        },
        setOfferDetailsOpen: (state, isOpen) => {
            state.offerDetailsOpen = isOpen;
        },
        setTourDetailsOpen: (state, isOpen) => {
            state.tourDetailsOpen = isOpen;
        },
        setAppId: (state, appId) => {
            state.appId = appId;
        },
        setCategories: (state, categories) => {
            state.categories = categories;
        },
        setKeyword: (state, keyword) => {
            state.filters.keyword = keyword;
        },
        addActiveCategory: (state, category) => {
            state.filters.categories.push(category);
            state.filters.categories = _.uniq(state.filters.categories,'id');
        },
        removeActiveCategory: (state, category) => {
            state.filters.categories = _.filter(state.filters.categories, cat => cat.id != category.id);
        },
        setMapIdle: (state, mapIdle) => {
            state.mapIdle = mapIdle;
        },
        setFeatureId: (state, featureId) => {
            state.featureId = featureId;
        },
        setMapType: (state, mapType) => {
            state.mapType = mapType;
        },
        setInitialFeaturesList: (state, initialList) => {
            if(Array.isArray(initialList)){
                state.initialFeaturesList = initialList;
            }
            else{
                console.log("initialList was not an array, setting empty array...");
                state.initialFeaturesList = [];
            }

        }
    },
    actions: {}
});
export default store;